<template>
  <div>
    <div class="d-flex justify-content-end mb-3">
      <b-button @click="handleAdd" ref="btnShow" size="sm" variant="primary" title="Add New">
        <i class="fa fa-plus" aria-hidden="true"></i>
        Add New
      </b-button>
    </div>

    <Grid
      :pageable="false"
      :resizable="false"
      :reorderable="false"
      :sortable="false"
      :row-height="25"
      :data-items="charges"
      :columns="fields"
      class="grid"
    >
      <template v-slot:commands="{props}">
        <td>
          <div class="d-flex align-items-center">
            <b-button
              size="sm"
              class="btn btn-primary"
              variant="primary"
              @click="handleEdit(props)"
            >
              <i class="fa fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              class="btn btn-danger"
              variant="primary"
              @click="handleDelete(props)"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </div>
        </td>
      </template>
    </Grid>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import fields from './fields';

export default {
  data: () => ({
    fields,
  }),
  computed: {
    ...mapGetters('quoteDetails', ['chargesById']),
    quoteId() {
      return this.$route.params.id;
    },
    charges() {
      return this.chargesById(this.quoteId);
    },
  },
  methods: {
    // @todo: Add CRUD logic
    handleAdd() {},
    handleEdit() {},
    handleDelete() {},
  },
  mounted() {
    // @todo: Load charges for given quote ID
  },
};
</script>
